export default function buildRemoveItemFromOrder({
    apiEndpoint,
    apiTools
}) {
    return async function removeItemFromOrder(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/item` 
        })
       
        const res = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(args.body)
        });
        return await res.json();
    }
}